import axios, { AxiosInstance } from 'axios';
import { useState, useCallback } from 'react';

type MultiUploadState = {
  loading: boolean;
};

const axiosInstance: AxiosInstance = axios.create();

const useS3MultiFileUpload = () => {
  const [state, setState] = useState<MultiUploadState>({
    loading: false,
  });

  const uploadSingle = useCallback(
    async ({ url, file }: SendFileUploadRequestParams): Promise<void> => {
      const options = {
        headers: {
          'Content-Type': file.type,
        },
      };

      const { status } = await axiosInstance.put(url, file, options);

      if (status !== 200) {
        throw new Error('Unable to upload file.');
      }
    },
    [],
  );

  const uploadMultiple = useCallback(
    async (
      requests: SendFileUploadRequestParams[],
    ): Promise<MultiUploadResult[]> => {
      setState({ loading: true });
      try {
        return await Promise.all(
          requests.map(async (req) => {
            try {
              await uploadSingle(req);
              return { file: req.file, success: true };
            } catch {
              return { file: req.file, success: false };
            }
          }),
        );
      } finally {
        setState({ loading: false });
      }
    },
    [uploadSingle],
  );

  return {
    loading: state.loading,
    uploadMultiple,
  };
};

export default useS3MultiFileUpload;
